"use client";

import { CmsErrorPage, type CmsErrorProps } from "@/core/CmsErrorPage";

export default function ErrorPage(props: CmsErrorProps) {
  return <CmsErrorPage {...props} />;
}
